import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type LaundryReservationGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

export const LaundryReservationGate: React.FC<LaundryReservationGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { laundryReservation } = useModuleConfig()

  const enabled = laundryReservation.enabled === true
  return enabled ? children : <Navigate to={redirectTo} replace />
}
